<template>
  <div>
    <div class="login">
      <div
        style="padding:20px 20px;
    text-align: left;
    display: flex;
    align-items: center;font-weight:bold;"
        @click="goback"
      >
        <mu-icon value="arrow_back"></mu-icon>
        {{this.$route.params.symbolName}}
      </div>
      <dl class="user-title">
        <dd>选择提现方式</dd>
      </dl>

      <div class="user-form">
   
        <mu-button color="primary"  full-width @click="tixian">银行卡提现</mu-button>
        <br>
        <mu-button color="primary"  full-width @click="tixian2">USDT提现</mu-button>
        
      </div>
      
    </div>
  </div>
</template>

<script>
import Api from "@/api";
export default {
  data() {
    return {
  
    };
  },
  mounted() {
   
  },
  activated() {
    
  },


  methods: {
    toLogin() {
      this.$router.push("/login");
    },
    goback() {
      this.$router.go(-1);
    },

tixian() {
      if(this.$store.state.user.tixianpass.length<2){
          this.$toast("为了您的资金安全,请设置资金密码")
          this.$router.push("/tixianpass")
        return ;
      };
      if(this.$store.state.user.hasOwnProperty("bankinfo") && this.$store.state.user.bankinfo.banknumber.length>5){
        this.$router.push(
            {
                path:"/tixian",
                query:{
                    way:"银行卡"
                }
            }
        );
        return;
      }
      else {
        this.$toast("请绑定银行卡")
        this.$router.push("/addbank")
      }
      
    },
      tixian2() {
      if(this.$store.state.user.tixianpass.length<2){
          this.$toast("为了您的资金安全,请设置资金密码")
          this.$router.push("/tixianpass")
        return ;
      };
      if(this.$store.state.user.hasOwnProperty("wallet") && this.$store.state.user.wallet.walletAddress.length>5){
         this.$router.push(
            {
                path:"/tixian",
                query:{
                    way:"USDT"
                }
            }
        );
        return;
      }
      else {
        this.$toast("请绑定USDT钱包")
        this.$router.push("/wallet")
      }
      
    },

  }
};
</script>

<style scoped>
.user-top {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.user-title {
  padding: 40px 20px;
  
  text-align: left;
  font-size: 2rem;
}
.user-form {
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.myinput {
  height: 50px;
  width: 80%;
  border: gray;
}
</style>>

</style>


// WEBPACK FOOTER //
// src/pages/TixianMode.vue